import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

export interface FieldProfile {
  name: string;
  email: string;
  phone?: string;
  positions: string[];
  payRateSummary?: string;
  certifications: { name: string; expiresAt?: string; ok?: boolean }[];
  recentClockHistory: { date: string; clockIn: string; clockOut?: string; hours?: number }[];
}

export function useFieldProfile() {
  return useQuery<FieldProfile>({
    queryKey: ['field-profile'],
    queryFn: () => api.field.profile().then((r) => r.data?.data ?? r.data),
    staleTime: 60_000,
  });
}
